import { Card, Image, Text, Button, Group, Badge, Menu, ActionIcon } from "@mantine/core";
import { IconDots, IconTrash, IconEdit } from "@tabler/icons-react";
import { motion } from "framer-motion";

export default function RoomsCard({ room, openRoom, deleteRoom }) {

  return (

    <motion.div
      whileHover={{ y: -6 }}
      transition={{ duration: 0.2 }}
    >

      <Card
        shadow="md"
        radius="xl"
        padding="0"
        withBorder
        style={{ overflow: "hidden" }}
      >

        {/* IMAGE */}

        <Card.Section style={{ position: "relative" }}>

          <Image
            src={room.photos?.[0] || "/placeholder.jpg"}
            height={200}
            fit="cover"
          />

          {/* PRICE BADGE */}

          <Badge
            color="indigo"
            radius="sm"
            style={{
              position: "absolute",
              top: 12,
              left: 12
            }}
          >
            {room.price} €
          </Badge>

          {/* ACTION MENU */}

          <Menu shadow="md" position="bottom-end">

            <Menu.Target>

              <ActionIcon
                variant="light"
                radius="xl"
                style={{
                  position: "absolute",
                  top: 10,
                  right: 10,
                  background: "white"
                }}
              >

                <IconDots size={18} />

              </ActionIcon>

            </Menu.Target>

            <Menu.Dropdown>

              <Menu.Item
                leftSection={<IconEdit size={16} />}
                onClick={() => openRoom(room)}
              >
                Modifier
              </Menu.Item>

              <Menu.Item
                color="red"
                leftSection={<IconTrash size={16} />}
                onClick={() => deleteRoom(room?._id)}
              >
                Supprimer
              </Menu.Item>

            </Menu.Dropdown>

          </Menu>

        </Card.Section>

        {/* CONTENT */}

        <div style={{ padding: 20 }}>

          <Group justify="space-between">

            <Text fw={600} size="lg">
              {room.title}
            </Text>

          </Group>

          <Text size="sm" c="dimmed" mt={4}>
            {room.maxPeople} personnes
          </Text>

          <Button
            fullWidth
            radius="xl"
            mt="md"
            variant="light"
            color="indigo"
            onClick={() => openRoom(room)}
          >
            Modifier
          </Button>

        </div>

      </Card>

    </motion.div>

  );
}